import { render, staticRenderFns } from "./ArticleDirectoryForm.vue?vue&type=template&id=86e561be&"
import script from "./ArticleDirectoryForm.vue?vue&type=script&lang=js&"
export * from "./ArticleDirectoryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports